import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UsersGridComponent } from './pages/users-grid/users-grid.component';
import { PatientsGridComponent } from './pages/patients-grid/patients-grid.component';

const routes: Routes = [
    // { path: '', redirectTo: 'users', pathMatch: 'full' },
    { path: "users", component: UsersGridComponent },
    { path: "patients", component: PatientsGridComponent },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [],
    declarations: [],
})
export class UsersRoutingModule { }
